<template>
  <div class="mb-6">
    <div class="flex items-center justify-between border-b border-gray-200">
      <nav class="-mb-px flex space-x-2 sm:space-x-8" aria-label="Tabs">
        <!-- Pestaña 1: Existencias por Depósito -->
        <button
          type="button"
          class="group inline-flex items-center gap-2.5 py-3 px-3 sm:px-4 border-b-2 font-medium text-sm transition-all cursor-pointer"
          :class="[
            modelValue === 'stock'
              ? 'border-orange-500 text-orange-600 font-bold'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          ]"
          @click="$emit('update:modelValue', 'stock')"
        >
          <div 
            class="w-7 h-7 rounded-lg flex items-center justify-center transition-colors"
            :class="[
              modelValue === 'stock'
                ? 'bg-orange-100 text-orange-600'
                : 'bg-gray-100 text-gray-400 group-hover:bg-gray-200 group-hover:text-gray-600'
            ]"
          >
            <i class="fa fa-warehouse text-xs" />
          </div>
          <span>Existencias por Depósito</span>
          <span
            v-if="stockCount !== null && stockCount !== undefined"
            class="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold"
            :class="[
              modelValue === 'stock'
                ? 'bg-orange-100 text-orange-700'
                : 'bg-gray-100 text-gray-600'
            ]"
          >
            {{ stockCount }}
          </span>
        </button>

        <!-- Pestaña 2: Lotes y Entradas -->
        <button
          type="button"
          class="group inline-flex items-center gap-2.5 py-3 px-3 sm:px-4 border-b-2 font-medium text-sm transition-all cursor-pointer"
          :class="[
            modelValue === 'batches'
              ? 'border-orange-500 text-orange-600 font-bold'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
          ]"
          @click="$emit('update:modelValue', 'batches')"
        >
          <div 
            class="w-7 h-7 rounded-lg flex items-center justify-center transition-colors"
            :class="[
              modelValue === 'batches'
                ? 'bg-orange-100 text-orange-600'
                : 'bg-gray-100 text-gray-400 group-hover:bg-gray-200 group-hover:text-gray-600'
            ]"
          >
            <i class="fa fa-clipboard-list text-xs" />
          </div>
          <span>Lotes y Entradas</span>
          <span
            v-if="batchCount !== null && batchCount !== undefined"
            class="hidden sm:inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold"
            :class="[
              modelValue === 'batches'
                ? 'bg-orange-100 text-orange-700'
                : 'bg-gray-100 text-gray-600'
            ]"
          >
            {{ batchCount }}
          </span>
        </button>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryTabs',

  props: {
    modelValue: {
      type: String,
      default: 'stock',
    },
    stockCount: {
      type: [Number, String],
      default: null,
    },
    batchCount: {
      type: [Number, String],
      default: null,
    },
  },

  emits: ['update:modelValue'],
}
</script>
